<template>
    <ResultsNetworkBanner bannerType="warning" header="In network">
        <ApplicationTier :result="result" :tierLabel="currentPlanTierLabel" v-if="currentPlanIsTiered && result.tier" />
        <span>
            Your plan covers emergency dental care only, not preventative dental care. Check your <a href="/my/plan-overview/coverage.html" :data-card-rank="rank">coverage details</a> to learn more.
        </span>
    </ResultsNetworkBanner>
</template>
    
<script setup>

const props = defineProps({
    result: Object,
    rank: Number
})

const { currentPlanTierLabel, currentPlanIsTiered } = useFCPModel()

</script>
